import { App, TierartEnum } from '@ps20-frontend/frontend-models';

export enum TgvProduktArt {
  TKV = 'TKV',
  THH_HUND = 'THH_HUND',
  THH_PFERD = 'THH_PFERD',
}

export interface TgvProduktlinieSnapshot {
  name: string;
  kurztext: string;
  selected: boolean;
  /** Price of this Produktlinie from the Strecken pricing, null until it arrived. */
  bruttopreis: number | null;
}

/** What the offer page knows about one product (child store) of the group. */
export interface TgvProduktSnapshot {
  key: string;
  art: TgvProduktArt;
  app: App;
  angebotsId?: string;
  /** TKV: the single animal; THH: all animals covered by the shared offer. */
  tierNamen: string[];
  tierart: TierartEnum;
  /** Whether the master product (Produkttabelle) arrived in the child store. */
  produktGeladen: boolean;
  linien: TgvProduktlinieSnapshot[];
  zahlweise: string;
}

/** Priced completely, so the child offer can be taken over into the dashboard. */
export const isProduktReady = (produkt: TgvProduktSnapshot): boolean =>
  produkt.produktGeladen &&
  produkt.linien.some(linie => linie.selected) &&
  produkt.linien.every(linie => linie.bruttopreis !== null);

export const areProdukteReady = (produkte: TgvProduktSnapshot[]): boolean =>
  produkte.length > 0 && produkte.every(isProduktReady);
